<template>
  <div class="phone-card fn-13">
    <div v-if="!loading" class="flex-c phone-body p-rel">
      <div v-if="phone.type == 'mobile_number'">
        <Phone-Call v-if="!isAlreadyOwned" class="call-fill-blue" />
        <Personal-Icon v-else viewBox="5 0 34 35">
          <title>Mobile Number</title>
        </Personal-Icon>
      </div>
      <div v-if="phone.type == 'direct_line'">
        <Phone-Call v-if="!isAlreadyOwned" class="call-fill-blue" />
        <Direct-Dial-Icon
          v-else
          viewBox="2 7 22 8"
          width="14px"
          height="14px"
          class="fill-blue"
        >
          <title>Direct Dial</title>
        </Direct-Dial-Icon>
      </div>
      <div v-if="phone.type == 'company_line'">
        <Phone-Call v-if="!isAlreadyOwned" class="call-fill-blue" />
        <Company-Icon v-else class="fill-blue">
          <title>Company Number</title>
        </Company-Icon>
      </div>
      <div v-if="phone.type == 'other'">
        <Phone-Call v-if="!isAlreadyOwned" class="call-fill-blue" />
        <Direct-Dial-Icon
          v-else
          viewBox="2 7 22 8"
          width="14px"
          height="14px"
          class="fill-blue"
        >
          <title>Phone Number</title>
        </Direct-Dial-Icon>
      </div>
      <div
        @mouseover="showCopyMsg = true"
        @mouseout="showCopyMsg = false"
        :class="[
          'fn-13 icon-img-spacing noselect flex-c',
          { cursor: profileData.contactAlreadyOwned },
        ]"
        @click="
          profileData.contactAlreadyOwned && isCopyEnabled
            ? copyClipboard(profileData.mcId, phone.number, 'number')
            : $event.preventDefault()
          showCopyMsg = false
        "
      >
        {{ phone.number }}
        <div v-if="phone.type != 'company_line'" class="p-rel flex-c">
          <Upgrade-Lock :type="phone.type" v-if="isAlreadyOwned" />
        </div>
      </div>
      <div v-if="showCopyMsg && isCopyEnabled" class="tooltip">
        Click to copy
      </div>
      <!-- <span>click to copy number</span> -->
      <input
        :id="profileData.mcId + 'number'"
        type="text"
        class="noVisibility"
      />
    </div>
    <div v-else class="flex-c">
      <div class="icon-hldr linear-background"></div>
      <div class="fn-13 icon-img-spacing linear-background"></div>
    </div>
    <Upgrade-Popup
      v-if="showPopup"
      :upgradePopupType="upgradePopupType"
      v-on:clickedOutside="showPopup = false"
    />
  </div>
</template>

<script>
import companyIcon from '@/assets/icons/svg/company.svg'
import personalIcon from '@/assets/icons/svg/personal-call.svg'
import directDialIcon from '@/assets/icons/svg/direct-dial-icon.svg'
import phoneCall from '@/assets/icons/svg/phone-call.svg'
import UpgradePopup from '@/components/UpgradePopup.vue'
import { get } from '@/assets/util/rest.js'
import sharedFunctions from '@/assets/util/functions.js'
import { MxEvent } from '@/assets/util/constants/analytics.js'
import UpgradeLock from '@/components/UpgradeLock.vue'

export default {
  name: 'PhoneCard',
  props: ['phone', 'loading', 'isContactOwned', 'profileData'],
  components: {
    'Company-Icon': companyIcon,
    'Direct-Dial-Icon': directDialIcon,
    'Personal-Icon': personalIcon,
    'Phone-Call': phoneCall,
    'Upgrade-Popup': UpgradePopup,
    'Upgrade-Lock': UpgradeLock,
  },
  data: function () {
    return {
      showPopup: false,
      showCopyMsg: false,
    }
  },
  computed: {
    isAlreadyOwned() {
      return this.profileData && this.profileData.email.indexOf('*') == -1
    },
    isCopyEnabled() {
      return (
        this.phone && this.phone.number && this.phone.number.indexOf('*') == -1
      )
    },
  },
  methods: {
    copyClipboard(cId, number, name) {
      let txtDisplay = 'Copied'
      const dataMap = {
        pageType: 'Bulk',
      }
      sharedFunctions.clickToCopy(
        cId,
        number,
        name,
        null,
        dataMap,
        txtDisplay,
        this.$store.state
      )
    },
  },
}
</script>

<style scoped lang="scss">
.phone-card {
  @extend .flex-c;
  padding-right: 15px;
  .icon-img-spacing {
    position: relative;
    margin: 0 0 0 8px;
  }
  .fill-blue,
  .call-fill-blue {
    fill: $primary-color;
  }
  .call-fill-blue {
    width: 13px;
    height: 13px;
  }
  .phone-body {
    position: relative;
  }
}
</style>
